import { CommonBaseData } from "../shared/data/common-base-data";
export class N3026OutputData extends CommonBaseData  {
  //出力帳票名
  public fileName: string;
  // ST-361 start
  // ダウンロード用ファイル名
  public downLoadFileName: string;
  // ST-361 end
}



// WEBPACK FOOTER //
// ./src/app/modules/n302/n3026-output-data.ts